module.exports = __webpack_public_path__ + "img/Group 1321315080@2x.c923bb16.png";